import styled from "@emotion/styled";
import { UnsupportedBehavior } from "@shopify/react-idle";
import { type FunctionComponent, useEffect, useState } from "react";

import { normalizeJsxAttribute, notEmpty } from "shared/lib/utils";

import { IdleQueue } from "scmp-app/components/common/idle-queue";
import type { ContentSchemaRenderProps } from "scmp-app/components/schema-render/content";

import { Container, StyledIframe } from "./styles";

type Props = ContentSchemaRenderProps & {
  className?: string;
  frameborder?: string;
  height?: string;
  id?: string;
  name?: string;
  scrolling?: string;
  src?: string;
  style?: string;
  title?: string;
  width?: string;
};

const defaultSize = "600";

export const Component: FunctionComponent<Props> = ({
  className,
  schemaNode,
  src: source = "",
  ...attribs
}) => {
  const {
    height = defaultSize,
    width = defaultSize,
    ...schemaAttributes
  } = schemaNode.attribs ?? {};

  const justifyWidth = (value: string) => {
    if (value.endsWith("%")) return defaultSize;
    if (value === "auto") return defaultSize;
    return width;
  };

  const parsedWidth = Number.parseFloat(justifyWidth(width));
  const parsedHeight = Number.parseFloat(height);

  const [iframeHeight, setIframeHeight] = useState(parsedHeight);

  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event?.data?.["datawrapper-height"] === undefined) {
        return;
      }

      const iframeId = attribs?.id ?? "";
      const chartId = iframeId.split("-").at(-1) ?? "";
      const dataWrapperHeight = event?.data?.["datawrapper-height"]?.[chartId] as
        | number
        | undefined;
      if (dataWrapperHeight !== undefined) setIframeHeight(dataWrapperHeight);
    };

    window.addEventListener("message", handler);
    return () => {
      window.removeEventListener("message", handler);
    };
  }, [attribs?.id]);
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */

  if (!notEmpty(source)) return null;

  return (
    <Container className={className}>
      <IdleQueue unsupportedBehavior={UnsupportedBehavior.AnimationFrame}>
        <StyledIframe
          {...normalizeJsxAttribute(schemaAttributes)}
          {...attribs}
          height={iframeHeight}
          src={source}
          style={{}}
          width={parsedWidth}
        />
      </IdleQueue>
    </Container>
  );
};

Component.displayName = "DataWrapperIframe";

export const DataWrapperIframe = styled(Component)``;
